var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/index.ts
export * from "react-router-dom";
export * from "history";

// src/route-component.tsx
import React, { createContext, useContext } from "react";
import { Route as BaseRoute } from "react-router-dom";
var RouteComponentContext = createContext(BaseRoute);
var RouteComponentProvider = ({
  children,
  routeComponent
}) => /* @__PURE__ */ React.createElement(RouteComponentContext.Provider, { value: routeComponent }, children);
var Route = (props) => {
  const RouteComponent = useContext(RouteComponentContext);
  return /* @__PURE__ */ React.createElement(RouteComponent, __spreadValues({}, props));
};

// src/browser-router.tsx
import {
  Router
} from "react-router-dom";
import { createBrowserHistory } from "history";
import React2 from "react";
var history = createBrowserHistory();
var BrowserRouter = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  /* @__PURE__ */ React2.createElement(Router, __spreadValues({ history }, props))
);

// src/use-query-params.hook.ts
import React3 from "react";
import { useLocation } from "react-router-dom";
var useQueryParams = () => {
  const { search } = useLocation();
  return React3.useMemo(() => new URLSearchParams(search), [search]);
};
export {
  BaseRoute,
  BrowserRouter,
  Route,
  RouteComponentProvider,
  history,
  useQueryParams
};
//# sourceMappingURL=index.js.map